export default {
  isShareContents: false,
}
